module.exports = __webpack_public_path__ + "static/media/crud_usuario_insert.007de42a.png";